export default "__VITE_ASSET__um5uOP3q__"